import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskReveal({ children, delay = 0, className }) {
  return (
    <motion.span
      className={`block overflow-hidden pb-[0.12em] -mb-[0.12em] ${className ?? ""}`}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
    >
      <motion.span
        className="block will-change-transform"
        variants={{
          hidden: { y: "115%" },
          show: { y: 0, transition: { duration: 1.1, delay, ease: EASE } },
        }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}

export function ChapterLabel({ index, title, testId, tone = "light" }) {
  const gold = tone === "dark" ? "#D4AF37" : "#B08D2E";
  return (
    <Reveal>
      <div className="flex items-center gap-5" data-testid={testId}>
        <span
          className="font-display text-lg italic leading-none"
          style={{ color: gold }}
        >
          {index}
        </span>
        <span
          className="h-px w-14"
          style={{ background: `linear-gradient(to right, ${gold}b3, ${gold}1a)` }}
        />
        <span
          className="text-[11px] font-medium uppercase tracking-[0.4em]"
          style={{ color: gold }}
        >
          {title}
        </span>
      </div>
    </Reveal>
  );
}
